export const FrontendStore = {
  cart: { items: [] },
  notificationCount: 0,
  cartItemCount: 0,
  countryCode: "",
  insuranceSelected: false,

  setCart(cart) {
    this.cart = cart || { items: [] }
    this.cartItemCount = this.cart.items?.length || 0
  },

  get cartIsEmpty() {
    if (!this.cart || !this.cart.items) return true
    return this.cart.items.length === 0
  },

  get selectedBrandId() {
    if (!this.cart || !this.cart.items) return null
    
    const selectedItems = this.cart.items.filter(item => item.selected)
    if (selectedItems.length === 0) return null
    
    // 取得第一個選中商品的品牌
    return selectedItems[0].brand
  },

  canSelectBrand(brandId) {
    const currentSelectedBrand = this.selectedBrandId
    return !currentSelectedBrand || currentSelectedBrand === brandId
  },
}
